<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">{{"NOTIFICATION" | translate}}</div>

    </div>

  </div>

  <div class="dropdown-content">

  </div>

</div>

